import ResponsiveListNavigation from "./ResponsiveListNavigation";

const ROOT = ".js-tabs-container";

if (document.querySelector(ROOT)) {

    const settings = {
      rootEl: ROOT,
      showIcon: false,
      type: "menu-item"
    };

    const rln = new ResponsiveListNavigation(settings);
    document.addEventListener("DOMContentLoaded", () => {
        rln.init();
    })
}
